(function ($) {
  $(function () {
    const servicesCard = $(".js-servcies-card");

    if (!servicesCard.length) {
      return;
    }

    const servicesCardHover = $(".js-services-card-text");

    servicesCard.hoverdir({hoverDelay: 75, hoverElem: servicesCardHover});
  });
})(jQuery);
